import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Media, Professional, ProfessionalCoverType } from '@adeo/ngx-kozikaza-api';
import { youtubeParser } from '../../../../../utils/misc/video';

@Component({
  selector: 'app-pro-carousel',
  templateUrl: './pro-carousel.component.html',
  styleUrls: ['./pro-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProCarouselComponent implements OnInit {
  @Input() pro: Professional;
  @Input() preloadImages = false;
  @Input() fetchPriority = false;
  @Input() miniCover = false;
  public coverTypesEnum = ProfessionalCoverType;
  public _currentSlide$: BehaviorSubject<number>;
  public proVideoId: string | false;
  public proCovers: Array<Media>;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (this.pro.coverType === ProfessionalCoverType.Video && this.pro.videoLink) {
      this.proVideoId = youtubeParser(this.pro.videoLink);
    } else if (this.pro.coverType === ProfessionalCoverType.Photos) {
      this._currentSlide$ = new BehaviorSubject(0);
    }

    this.proCovers = this.pro.covers
      .filter((cover) => typeof cover !== 'string')
      .map((cover) => typeof cover !== 'string' ? cover : null);
    this.cd.detectChanges();
  }

  // Media Slider
  set currentSlide(slideIndex: number) {
    this._currentSlide$.next(slideIndex);
    this.cd.detectChanges();
  }
  get currentSlide(): number {
    return this._currentSlide$.getValue();
  }
  get currentSlide$(): Observable<number> {
    return this._currentSlide$.asObservable();
  }
}
